import { fontSmoothing, getFontFamily } from '../../typography';
import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    margin: 0,
    padding: 16,
    borderRadius: 0,
    height: 40,
    minHeight: 0,
    boxSizing: 'border-box',
    fontSize: idsTokens.typography.font.size.base,
    fontFamily: getFontFamily(idsTokens),
    ...fontSmoothing,
    color: idsTokens.listItem.default.color.text.label.enabled,
    fontWeight: idsTokens.typography.font.weight.regular,
    lineHeight: idsTokens.typography.lineHeight.base,
    letterSpacing: idsTokens.typography.spacing.letter.lg,
    '&:hover, &.Mui-selected:hover, &:focus:not([data-value=""])': {
      backgroundColor: idsTokens.listItem.default.color.background.hover,
      color: idsTokens.listItem.default.color.text.label.focus,
    },
    '&:focus[data-value=""]': {
      backgroundColor: idsTokens.listItem.default.color.background.focus,
    },
    '&.Mui-selected': {
      backgroundColor: 'transparent',
      '&:not([data-value=""])': {
        color: idsTokens.listItem.default.color.text.label.focus,
        fontWeight: idsTokens.typography.font.weight.medium,
      },
    },
    '& > svg': {
      position: 'absolute',
      left: 8,
    },
    '@media (min-width:600px)': {
      minHeight: 0,
    },
    // Column-settings row: Figma PXDS-7661 = padding + 21px content band (leadingIcon); checkbox may overflow into padding
    '&.IDS-columnSettingsMenuItem': {
      alignItems: 'center',
      height: 'auto',
      minHeight: `calc(${idsTokens.columnSettingsMenu.default.padding.menuItem.top} + ${idsTokens.columnSettingsMenu.default.height.leadingIcon} + ${idsTokens.columnSettingsMenu.default.padding.menuItem.bottom})`,
      overflow: 'visible',
    },
  },
  gutters: {
    paddingLeft: 16,
    paddingRight: 16,
  },
});
